<script>
	export default {
		props:{
			id:{default:'page'},
		},
		
		data(){
			return {
				pageData:{},
			}
		},
		
		methods: {},
		
		mounted(){},
		
		created(){}
	}
</script>

<template>
	<div>
		<slot :data="pageData"></slot>
	</div>
</template>


// WEBPACK FOOTER //
// resources/assets/js/views/pages/page-home.vue